import GroupLinkedDevice from "../../model/GroupLinkedDevice";
import { getStartOfDayFrom } from "../trip/tripHelper";

export function getGroupDeviceLinksForPastTwoDaysAndModifiedEntities(groupDeviceLinks: IIdDictionary<IIdDictionary<GroupLinkedDevice>>) {
    let fromDate = getStartOfDayFrom(2);
    let filteredGroupDeviceLinks: IIdDictionary<IIdDictionary<GroupLinkedDevice>> = {};

    Object.keys(groupDeviceLinks).forEach(deviceId => {
        Object.keys(groupDeviceLinks[deviceId]).forEach(groupDeviceId => {
            if (groupDeviceLinks[deviceId][groupDeviceId].from >= fromDate.toISOString() || groupDeviceLinks[deviceId][groupDeviceId].modified) {
                if (filteredGroupDeviceLinks[deviceId]) {
                    filteredGroupDeviceLinks[deviceId][groupDeviceId] = new GroupLinkedDevice(groupDeviceLinks[deviceId][groupDeviceId]);
                } else {
                    filteredGroupDeviceLinks[deviceId] = {[groupDeviceId]: new GroupLinkedDevice(groupDeviceLinks[deviceId][groupDeviceId])};
                }
            }
        });
    });

    return filteredGroupDeviceLinks;
}